export enum CartSortByValue {
  NEWEST = "newest",
  OLDEST = "oldest",
  TOTAL_HIGH_TO_LOW = "total_high_to_low",
  TOTAL_LOW_TO_HIGH = "total_low_to_high",
}
